const _ = require("lodash");

const ArrowSequence = require("./commands/ArrowSequence");
const BotHistory = require("./commands/BotHistory");
const BotImage = require("./commands/BotImage");
const BottomAlign = require("./commands/BottomAlign");
const BotIcons = require("./commands/BotIcons");
const BotSprite = require("./commands/BotSprite");
const Boxes = require("./commands/Boxes");
const Calendar = require("./commands/Calendar");
const Circle = require("./commands/Circle");
const Color = require("./commands/Color");
const ElevatorButton = require("./commands/ElevatorButton");
const Encircle = require("./commands/Encircle");
const ExampleBlock = require("./commands/ExampleBlock");
const Hands = require("./commands/Hands");
const Icons = require("./commands/Icons");
const Lizzie = require("./commands/Lizzie");
const MiniShape = require("./commands/MiniShape");
const Mirror = require("./commands/Mirror");
const NumberFrame = require("./commands/NumberFrame");
const Overlay = require("./commands/Overlay");
const Phantom = require("./commands/Phantom");
const PirateNumber = require("./commands/PirateNumbers");
const ReadAloudOverride = require("./commands/ReadAloudOverride");
const RotationArrow = require("./commands/RotationArrow");
const Size = require("./commands/Size");
const SkipCountCell = require("./commands/SkipCountCell");
const SumStrip = require("./commands/SumStrip");
const SymbolCmd = require("./commands/Symbol");
const TextBackslash = require("./commands/TextBackslash");
const TextFormatting = require("./commands/TextFormatting");
const Units = require("./commands/Units");
const UnmaskButton = require("./commands/UnmaskButton");
const XAndOSymbols = require("./commands/XAndOSymbols");

const bundles = [
	ArrowSequence,
	BotHistory,
	BotImage,
	BotIcons,
	BotSprite,
	BottomAlign,
	Boxes,
	Calendar,
	Circle,
	Color,
	ElevatorButton,
	Encircle,
	ExampleBlock,
	Hands,
	Icons,
	Lizzie,
	MiniShape,
	Mirror,
	NumberFrame,
	Overlay,
	Phantom,
	PirateNumber,
	ReadAloudOverride,
	RotationArrow,
	Size,
	SkipCountCell,
	SumStrip,
	SymbolCmd,
	TextBackslash,
	TextFormatting,
	Units,
	UnmaskButton,
	XAndOSymbols,
];

const CommandIndex = {
	parsers: {
		mathCommands: _.extend(
			{},
			...bundles.map(bundle =>
				!bundle.parsers ? {} : bundle.parsers.mathCommands
			)
		),
		nonmathCommands: _.extend(
			{},
			...bundles.map(bundle =>
				!bundle.parsers ? {} : bundle.parsers.nonmathCommands
			)
		),
		mathEnvironments: _.extend(
			{},
			...bundles.map(bundle =>
				!bundle.parsers ? {} : bundle.parsers.mathEnvironments
			)
		),
		nonmathEnvironments: _.extend(
			{},
			...bundles.map(bundle =>
				!bundle.parsers ? {} : bundle.parsers.nonmathEnvironments
			)
		),
	},
	nodes: _.extend({}, ...bundles.map(bundle => bundle.nodes)),
};

module.exports = CommandIndex;
